import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { RefillAlertsCount } from "../../Apis/AuthApiServices";
import {
  loadingRefillAlertsCount,
  setRefillAlertsCount,
} from "../Slice/RefillAlertsCountSlice";

function* onLoadRefillAlertsCountAsync({ payload }: any) {
  const params = new URLSearchParams();
  let doctorId: any = localStorage.getItem("doctorId");
  params.append("doctorId", doctorId);
  params.append("pageNumber", payload.pageNumber);
  params.append("pageSize", payload.pageSize);
  try {
    const result: AxiosResponse = yield RefillAlertsCount(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setRefillAlertsCount({
          RefillAlertsCountData: result?.data?.response,
          Items: result?.data?.response[0]?.items,
          Pagination: result?.data?.response[0]?.pagination,
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setRefillAlertsCount({
          RefillAlertsCountData: [],
          error: false,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error: any) {
    yield put(
      setRefillAlertsCount({
        RefillAlertsCountData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadRefillAlertsCount() {
  yield takeLatest(loadingRefillAlertsCount.type, onLoadRefillAlertsCountAsync);
}

const RefillAlertsCountSaga = [fork(onLoadRefillAlertsCount)];
export default RefillAlertsCountSaga;
